import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const NoReviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;

  margin: 4rem 0;

  @media (min-width: ${breakpoints.md}) {
    max-width: 23rem;
    margin: 4rem auto;
  }
`;

export const NoReviewsDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;

  text-align: center;
`;
